// extracted by css-extract-rspack-plugin
export default {"status":"status-OY1MHv"};